const rbacService = {
};
export function hasPrivilege(userPrivileges: any, privilege: string) {
  return userPrivileges?.has(privilege);
}
export default rbacService;
